import { ReactNode } from "react";
import { InboxIcon } from "../../icons";
import styles from "./EmptyState.module.css";

export type EmptyStateProps = {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
};

export const EmptyState = ({ icon, title, description, action }: EmptyStateProps) => (
  <div className={styles.emptyState}>
    <span className={styles.iconSlot}>{icon ?? <InboxIcon size={28} />}</span>
    <span className={styles.title}>{title}</span>
    {description ? <span className={styles.description}>{description}</span> : null}
    {action}
  </div>
);
